import { HttpContextToken, HttpErrorResponse, HttpRequest } from '@angular/common/http';

/**
 * Codici `errorCode` per cui l'interceptor non mostra il toaster.
 * La pagina che imposta il contesto gestisce l'errore.
 */
export const SUPPRESS_HTTP_ERROR_ALERT_CODES = new HttpContextToken<readonly string[]>(() => []);

export const shouldSuppressHttpErrorAlert = (
  request: HttpRequest<unknown>,
  error: HttpErrorResponse,
): boolean => {
  const errorCode = readErrorCode(error);
  return !!errorCode && request.context.get(SUPPRESS_HTTP_ERROR_ALERT_CODES).includes(errorCode);
};

const readErrorCode = (error: HttpErrorResponse): string | null => {
  const body = error.error;
  if (typeof body !== 'object' || body === null) {
    return null;
  }

  const errorCode = (body as { errorCode?: unknown }).errorCode;
  return typeof errorCode === 'string' ? errorCode : null;
};
